import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { SmartModal } from "soft_digi";
import { useSiteContext } from "../contexts/SiteProvider";

import HomeRoutes from "./HomeRoutes";

import { Toaster } from "react-hot-toast";
import Login from "../Pages/Login/Login";

const SiteRoute = () => {
  const { modalOptions, closeModal } = useSiteContext();

  return (
    <Router>
      <Routes>
          <Route path="/login" element={<Login />} />
      {HomeRoutes()}
      
      
      </Routes>
      {/* {isModalOpen && <SmartModal active={isModalOpen} {...modalOptions} closeFunction={closeModal} />} */}

      {modalOptions?.map((modal: any, i: number) => (
        <div key={i}>
          <SmartModal 
            active={true} 
            {...modal} 
            closeFunction={modal?.closeFunction || (() =>closeModal("again"))} 
          />
        </div>
      ))}
      <Toaster />
    </Router>
  );
};

export default SiteRoute;

/* <Layout>
      <Router>
        <Routes>
          <Route path="/table/:type" element={<TableIndex />} />
          <Route path="/tabs/:type" element={<TabsExample />} />
          <Route path="/modals/:type" element={<ModalExampls />} />
          <Route path="/buttons/:type" element={<Buttons />} />
          <Route path="/sliders/:type" element={<Sliders />} />
          <Route path="/calenders/:type" element={<Calanders />} />

         
          <Route path="/lnpr" element={<HomeLanding />} />

          <Route path="/tracker" element={<VerticalOrderTracker />} />
          <Route path="/trackers" element={<Tracker currentStep={currentStep} />} />
          <Route path="/loader" element={<SmartLoader />} />
          <Route path="/sign" element={<SignPad />} />
          <Route path="/webcam" element={<WebCam />} />
          <Route path="/Charts" element={<Charts />} />
          <Route path="/forms" element={<StepForms />} />
          <Route path="/forms-text-box" element={<Forms />} />

          <Route path="/stars" element={<StarRatingDisplay />} />
          <Route path="/nestedtable" element={<NestedTable />} />
          <Route path="/forms-text-area" element={<TextArea />} />
          <Route path="/forms-select-box" element={<SelectBox />} />
          <Route path="/forms-radio" element={<Radio />} />
          <Route path="/forms-files-upload" element={<FileUpload />} />
          <Route path="/forms-files-validation" element={<FormValidation />} /> 

        </Routes>
        {isModalOpen && <SmartSoftModal active={isModalOpen} {...modalOptions} closeFunction={closeModal} />}
      </Router>
      <ToastContainer />
    </Layout> */
